/*
  Geoff Thomas Designs - product page behaviour
  1. Gallery: stage arrows, keyboard, live counter, keep the active thumbnail in view.
     Dawn's media-gallery.js still owns which media is active; this only drives it.
  2. Works well with: <gtd-recommendations> loads Shopify related products when the
     merchant has not picked any, arrows scroll the card track, variant select and
     add to cart happen inside the card and open the cart drawer.
*/
(function () {
  'use strict';

  /* ---------------------------------------------------------------- gallery */
  function visibleThumbs(thumbs) {
    return Array.from(thumbs.querySelectorAll('.thumbnail-list__item')).filter(function (li) {
      return li.offsetParent !== null && li.clientWidth > 0;
    });
  }

  function setupGallery(gallery) {
    if (gallery.dataset.gtdReady) return;
    gallery.dataset.gtdReady = '1';

    var thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    var current = gallery.querySelector('[data-gtd-current]');
    var navs = gallery.querySelectorAll('[data-gtd-nav]');

    if (!thumbs || !viewer) {
      navs.forEach(function (b) { b.hidden = true; });
      if (current && current.parentElement) current.parentElement.hidden = true;
      return;
    }

    function activeIndex(items) {
      for (var i = 0; i < items.length; i += 1) {
        if (items[i].querySelector('button[aria-current]')) return i;
      }
      return 0;
    }

    function keepInView(li) {
      var list = thumbs.querySelector('.thumbnail-list');
      if (!list || !li) return;
      var lr = list.getBoundingClientRect();
      var ir = li.getBoundingClientRect();
      var top = ir.top - lr.top + list.scrollTop - (lr.height - ir.height) / 2;
      var left = ir.left - lr.left + list.scrollLeft - (lr.width - ir.width) / 2;
      list.scrollTo({ top: Math.max(0, top), left: Math.max(0, left), behavior: 'smooth' });
    }

    function sync() {
      var items = visibleThumbs(thumbs);
      var counter = current && current.parentElement;
      if (!items.length) {
        /* thumbnails hidden at this breakpoint: Dawn's own counter is the live one */
        if (counter) counter.hidden = true;
        return;
      }
      if (counter) counter.hidden = false;
      var idx = activeIndex(items);
      if (current) current.textContent = String(idx + 1);
      keepInView(items[idx]);
    }

    function step(dir) {
      var items = visibleThumbs(thumbs);
      if (items.length < 2) return;
      var idx = activeIndex(items);
      var next = items[(idx + dir + items.length) % items.length];
      var button = next && next.querySelector('button');
      if (button) button.click();
    }

    navs.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        step(Number(button.dataset.gtdNav) || 1);
      });
    });

    gallery.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') { event.preventDefault(); step(1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); step(-1); }
    });

    var observer = new MutationObserver(function () { window.requestAnimationFrame(sync); });
    observer.observe(thumbs, { attributes: true, subtree: true, attributeFilter: ['aria-current'] });

    /* mobile swipe: Dawn's slider dispatches slideChanged and media-gallery marks the thumb,
       the observer above catches that. Belt and braces for the counter on scroll end. */
    viewer.addEventListener('slideChanged', function () { window.setTimeout(sync, 60); });

    sync();
  }

  function initGalleries() {
    document.querySelectorAll('media-gallery.gtd-gallery').forEach(setupGallery);
  }

  /* --------------------------------------------------- works well with cards */
  function cartSections() {
    if (document.querySelector('cart-drawer')) return 'cart-drawer,cart-icon-bubble';
    if (document.querySelector('cart-notification')) return 'cart-notification-product,cart-notification-button,cart-icon-bubble';
    return 'cart-icon-bubble';
  }

  function addToCart(button) {
    var card = button.closest('.gtd-www__card');
    var select = card && card.querySelector('.gtd-www__select');
    var variantId = select ? select.value : button.dataset.variantId;
    var price = select ? select.options[select.selectedIndex].dataset.priceRaw : button.dataset.price;
    var fallbackUrl = button.dataset.url;
    var label = button.querySelector('[data-gtd-label]');
    var idle = label ? label.textContent : '';
    var root = button.closest('gtd-recommendations');
    var addUrl = (root && root.dataset.cartAddUrl) || '/cart/add';
    var cartUrl = (root && root.dataset.cartUrl) || '/cart';
    var currency = (root && root.dataset.currency) || 'USD';

    if (!variantId) { window.location.href = fallbackUrl; return; }

    button.classList.add('is-busy');

    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      /* single item shape: the response carries the line item key that cart-notification needs */
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        sections: cartSections(),
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        return response.json();
      })
      .then(function (data) {
        var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(data);
        } else {
          window.location.href = cartUrl;
          return;
        }
        if (typeof window.fbq === 'function') {
          window.fbq('track', 'AddToCart', {
            content_ids: [String(variantId)],
            content_type: 'product',
            value: parseFloat(price || 0),
            currency: currency
          });
        }
        /* PUB_SUB_EVENTS is a top level const in constants.js, so it is not on window */
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gtd-works-well-with', cartData: data });
        }
        button.classList.remove('is-busy');
        button.classList.add('is-added');
        if (label) label.textContent = 'Added';
        window.setTimeout(function () {
          button.classList.remove('is-added');
          if (label) label.textContent = idle;
        }, 1800);
      })
      .catch(function () {
        button.classList.remove('is-busy');
        window.location.href = fallbackUrl;
      });
  }

  function onSelectChange(select) {
    var card = select.closest('.gtd-www__card');
    var option = select.options[select.selectedIndex];
    var price = card && card.querySelector('[data-gtd-price]');
    var button = card && card.querySelector('.gtd-www__add');
    if (price && option.dataset.price) price.innerHTML = option.dataset.price;
    if (button) button.dataset.variantId = option.value;
  }

  /* the theme editor re-runs section scripts on block changes; bind the delegated handlers once */
  if (!window.__gtdPdpBound) {
  window.__gtdPdpBound = true;

  document.addEventListener('click', function (event) {
    var add = event.target.closest('.gtd-www__add');
    if (add) { event.preventDefault(); addToCart(add); return; }
    var arrow = event.target.closest('.gtd-www__arrow');
    if (arrow) {
      event.preventDefault();
      var root = arrow.closest('gtd-recommendations');
      if (root && typeof root.scrollByCard === 'function') root.scrollByCard(Number(arrow.dataset.dir) || 1);
    }
  });

  document.addEventListener('change', function (event) {
    var select = event.target.closest('.gtd-www__select');
    if (select) onSelectChange(select);
  });
  }

  if (!customElements.get('gtd-recommendations')) {
    customElements.define(
      'gtd-recommendations',
      class GtdRecommendations extends HTMLElement {
        connectedCallback() {
          var self = this;
          this.setupTrack();
          if (this.dataset.mode !== 'auto' || this.dataset.loaded) return;
          this.dataset.loaded = '1';
          var url = this.dataset.url + '&product_id=' + this.dataset.productId + '&section_id=' + this.dataset.sectionId;
          fetch(url)
            .then(function (r) { return r.text(); })
            .then(function (text) {
              var html = document.createElement('div');
              html.innerHTML = text;
              var fresh = html.querySelector('gtd-recommendations');
              if (fresh && fresh.dataset.source === 'related' && fresh.querySelector('.gtd-www__card')) {
                self.innerHTML = fresh.innerHTML;
                self.dataset.source = 'related';
                self.setupTrack();
              }
            })
            .catch(function () { /* keep the server rendered fallback */ });
        }

        setupTrack() {
          var self = this;
          this.track = this.querySelector('.gtd-www__track');
          if (!this.track) return;
          this.updateArrows();
          this.track.addEventListener('scroll', function () {
            window.clearTimeout(self.scrollTimer);
            self.scrollTimer = window.setTimeout(function () { self.updateArrows(); }, 80);
          });
          if (window.ResizeObserver) {
            new ResizeObserver(function () { self.updateArrows(); }).observe(this.track);
          }
        }

        cardWidth() {
          var card = this.track && this.track.querySelector('.gtd-www__card');
          if (!card) return 0;
          var gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap || 0) || 0;
          return card.getBoundingClientRect().width + gap;
        }

        scrollByCard(dir) {
          if (!this.track) return;
          this.track.scrollBy({ left: this.cardWidth() * dir, behavior: 'smooth' });
        }

        updateArrows() {
          if (!this.track) return;
          var prev = this.querySelector('.gtd-www__arrow[data-dir="-1"]');
          var next = this.querySelector('.gtd-www__arrow[data-dir="1"]');
          var max = this.track.scrollWidth - this.track.clientWidth;
          var nav = this.querySelector('.gtd-www__nav');
          if (nav) nav.hidden = max < 4;
          if (prev) prev.disabled = this.track.scrollLeft <= 2;
          if (next) next.disabled = this.track.scrollLeft >= max - 2;
        }
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleries);
  } else {
    initGalleries();
  }

  /* variant changes re-render the section in Dawn 15 (product-info.js swaps media markup) */
  if (!window.__gtdPdpGlobalBound) {
    window.__gtdPdpGlobalBound = true;
    document.addEventListener('shopify:section:load', initGalleries);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { window.setTimeout(initGalleries, 50); });
    }
  }
})();
